import ItemListByCategory from "./ItemListByCategory"
import CategoryItems from "./CategoryItems"
import CategoryCards from "../Categories/CategoryCards"
import { ScrollShadow } from "@nextui-org/react"
import { AppParamsContext } from "contexts/AppParamsContext"
import { useContext } from "react"

export default function ItemList({
  selectedCategory,
  setSelectedCategory,
  readOnly,
}) {
  const { appParams } = useContext(AppParamsContext)

  if (
    appParams?.features?.selectedCategoryItemsOnly ||
    appParams?.order?.selectedCategoryItemsOnly
  )
    return (
      <>
        {selectedCategory !== "" && (
          <ScrollShadow>
            <div
              id="orderItemList-byCategory"
              className="orderItemList-byCategory-root scroll-shadow max-w-[500px]"
            >
              <CategoryItems
                selectedCategory={selectedCategory}
                readOnly={readOnly}
              />
            </div>
          </ScrollShadow>
        )}
        {selectedCategory === "" && (
          <CategoryCards setSelectedCategory={setSelectedCategory} />
        )}
      </>
    )
  return <ItemListByCategory readOnly={readOnly} />
}
